/**
 * Sidebar/hooks/useSetupOpen/index.ts
 * desc: open state of the sidebar's Setup accordion — persisted, open by default
 */

import { useCallback } from 'react';
import { useLocalStorage } from 'usehooks-ts';

export const SETUP_OPEN_STORAGE_KEY = 'navSetupOpen';

const useSetupOpen = () => {
    const [ isOpen, setIsOpen ] = useLocalStorage(SETUP_OPEN_STORAGE_KEY, true);
    const toggle = useCallback(() => setIsOpen((current) => !current), [ setIsOpen ]);

    return { isOpen, toggle };
};

export default useSetupOpen;
